import { Button, Col, message } from "antd";
import { Link, useHistory } from "react-router-dom";
import { useEffect, useMemo, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { DataTableLayout } from "common/components/dataTableLayout/dataTableLayout";
import { usePageFilter } from "hooks/usePageFilters";
import Export from "redux/models/export";
import { selectUserId, selectUserRoles } from "redux/slices/userSlice";
import { ExportDataButton } from "common/components/ExportDataButton";
import K from "../../../utilities/constants";
import User from "../../../redux/models/user";
import { getColumns } from "./columns";

export const UsersContainer = ({ type, renderTable }) => {
  const history = useHistory();

  const userId = useSelector(selectUserId);
  const roles = useSelector(selectUserRoles);

  const [data, setData] = useState(null);

  const [search, setSearch] = usePageFilter("users_search");

  const gridRef = useRef(null);

  const columns = useMemo(() => getColumns(roles), [roles]);

  const onRowClicked = (event) => {
    history.push(`/configurations/users/detail/${event.data.id}`);
  };

  const onExportRequested = async () => {
    try {
      const { columnApi } = gridRef.current;
      const sortColumn = columnApi.getColumnState().find((c) => c.sort);

      const params = {
        type,
        search: search ?? undefined,
        sortBy: sortColumn?.colId,
        sortOrder: sortColumn?.sort,
      };

      await Export.getReportUsers(params);

      message.success(
        "Users export request successfully received! Check your email shortly",
      );
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    const getData = async () => {
      try {
        const res = await User.getAll({ type });
        setData(res);
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    };

    getData();
  }, [type]);

  return (
    <DataTableLayout
      searchDefaultValue={search}
      onSearchChange={setSearch}
      actions={[
        {
          renderer: () => (
            <Col>
              <ExportDataButton
                onClick={onExportRequested}
                disabled={data?.length === 0}
              />
            </Col>
          ),
        },
        {
          permissions: [K.Permissions.CreateUser],
          renderer: () => (
            <Col>
              <Link to="/configurations/users/create">
                <Button type="primary">Create User</Button>
              </Link>
            </Col>
          ),
        },
      ]}
    >
      {renderTable({
        ref: gridRef,
        userId,
        configKey: `${K.AgGridTable.Keys.UserVisibleColumn}-${type}`,
        defaultColumnConfig: columns,
        rowData: data,
        quickFilterText: search,
        onRowClicked,
      })}
    </DataTableLayout>
  );
};
